import request from '@/utils/request'

export function updateCoinPopCfg(data) {
  return request({
    url: 'api/v1/shop-not-enough/updateCfg',
    method: 'post',
    data: data
  })
}

export function getCoinPopList(data) {
  return request({
    url: 'api/v1/shop-not-enough/getCfg',
    method: 'post',
    data: data
  })
}

export function delCoinPopList(data) {
  return request({
    url: 'api/v1/shop-not-enough/delCfg',
    method: 'delete',
    data: data
  })
}
